<template>
	<div class="manage">
		<div class="top" style="margin: 0px;">


			<!-- 订单列表 -->
			<el-row v-if="!showDetail">
				<el-col :span="24" class="table" style="margin: 0px;">
					<div ref="height_top" class="order-card-container"
						:style="{ height: tableHeight - 20 + 'px', overflowY: 'auto' }">

						<div v-loading="loading" class="order-card-list">

							<div v-for="order in tableData" :key="order.key" class="order-card">
								<div class="card-header">
								<div class="header-item">
									<span class="item-label">订单日期</span>
									<span class="item-value">{{ order.create_time }}</span>
								</div>
								<div class="header-item">
									<span class="item-label">订单号</span>
									<span class="item-value order-no">{{ order.pay_no }}</span>
								</div>
								<div class="header-item">
									<span class="item-label">快递单号</span>
									<span class="item-value" v-if="order.express_company && order.express_code">{{
										order.express_company }}:{{ order.express_code }}</span>
									<span class="item-value" v-else>-</span>
								</div>
								<div class="confirm-tip" v-if="order.state === 3">
									<el-icon><Clock /></el-icon>
									订单正在确认中，商家确认后可进行支付！
								</div>

								<div class="confirm-tip" v-else-if="order.state === 0">
									<el-icon><Clock /></el-icon>
									商家已确认订单，可进行支付！
								</div>
							</div>
								<div class="card-body">
									<div class="body-left">
										<div class="info-row">
											<div class="info-item">
												<span class="info-label">商品数量</span>
												<span class="info-value">{{ order.total_num || 0 }} 件</span>
											</div>
											<div class="info-item">
												<span class="info-label">订单金额</span>
												<span class="info-value price">¥{{ order.total_order_money }}</span>
											</div>
											<div class="info-item">
												<span class="info-label">商品金额</span>
												<span class="info-value price">¥{{ order.total_goods_money }}</span>
											</div>
											<div class="info-item" v-if="Number(order.goods_discount) > 0">
										<span class="info-label">优惠金额</span>
										<span class="info-value discount">
											<el-tag type="danger" size="small" effect="dark">省</el-tag>
											¥{{ order.goods_discount || '0.00' }}
										</span>
									</div>
									<div class="info-item">
										<span class="info-label">运费</span>
										<span class="info-value price">¥{{ order.freight_fee || '0.00'
										}}</span>
									</div>
										</div>
										<div class="status-row">
											<el-tag :type="getStatusType(order)" size="small">{{
												getStatusText(order) }}</el-tag>
										</div>
									</div>
									<div class="body-right">
										<el-button v-if="order.state === 0 || order.state === 3" type="danger" size="small"
											@click="handleCancelOrder(order)">取消订单</el-button>
										<el-button type="info" size="small" color="#ff8a5c" style="color: white;"
											@click="handleReorder(order)">再次下单</el-button>
										<el-button
											v-if="order.state === 0  && !(order.state === 0 && order.card_state === 1)"
											type="primary" size="small" text @click="goToPay(order)">去支付</el-button>
										<el-button v-if="order.state === 2" type="primary" size="small"
											@click="handleConfirmReceipt(order)">确认收货</el-button>
										<el-button
											v-if="order.state !== 0  || (order.state === 0 && order.card_state === 1)"
											type="primary" size="small" text @click="viewDetail(order)">查看详情</el-button>
									</div>
								</div>
							</div>
							<div v-if="tableData.length === 0" :style="{ height: tableHeight - 20 + 'px' }">
								<el-empty description="暂无数据" :image-size="120">
									<template #description>
										<div class="empty-title">暂无数据</div>
										<div class="empty-subtitle"></div>
									</template>
								</el-empty>

							</div>

						</div>
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background
						:page-size="parseInt(page_size)" layout="prev, pager, next"
						@current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>

			<!-- 订单详情 -->
			<el-row v-else>
				<el-col :span="24">
					<div class="detail-header">
						<el-button type="primary" size="small" text @click="backToList">
							<el-icon>
								<ArrowLeft />
							</el-icon> 返回列表
						</el-button>
					</div>
					<div class="order-detail-page" ref="detailRef">
						<div class="order-container scroll-container" :style="{ height: (tableHeight) + 'px' }"
							style="overflow: auto;" v-loading="loading">
							<!-- 订单流程 -->
							<div class="order-section order-progress-section">
								<div class="progress-steps">
									<el-steps :space="200" :active="currentStepIndex" finish-status="success"
								align-center>
								<el-step>
									<template #icon>
										<div class="step-icon-wrapper create-icon">
											<el-icon>
												<DocumentAdd />
											</el-icon>
										</div>
									</template>
									<template #title>
										<span class="step-title">创建订单</span>
									</template>
									<template #description>
										<span class="step-time">{{ currentOrder.create_time || '--' }}</span>
									</template>
								</el-step>
								<el-step>
									<template #icon>
										<div class="step-icon-wrapper confirm-icon">
											<el-icon>
												<Checked />
											</el-icon>
										</div>
									</template>
									<template #title>
										<span class="step-title">商家确认</span>
									</template>
									<template #description>
										<span class="step-time">{{ currentOrder.create_time || '--' }}</span>
									</template>
								</el-step>
								<el-step>
									<template #icon>
										<div class="step-icon-wrapper pay-icon">
											<el-icon>
												<Wallet />
											</el-icon>
										</div>
									</template>
									<template #title>
										<span class="step-title">待支付</span>
									</template>
									<template #description>
										<span class="step-time">{{ currentOrder.affirm_time || '--' }}</span>
									</template>
								</el-step>
								<el-step>
									<template #icon>
										<div class="step-icon-wrapper ship-icon">
											<el-icon>
												<Box />
											</el-icon>
										</div>
									</template>
									<template #title>
										<span class="step-title">待发货</span>
									</template>
									<template #description>
										<span class="step-time">{{ currentOrder.confirm_time || '--' }}</span>
									</template>
								</el-step>
								<el-step>
									<template #icon>
										<div class="step-icon-wrapper receive-icon">
											<el-icon>
												<Van />
											</el-icon>
										</div>
									</template>
									<template #title>
										<span class="step-title">待收货</span>
									</template>
									<template #description>
										<span class="step-time">{{ currentOrder.express_time || '--' }}</span>
									</template>
								</el-step>
								<el-step>
									<template #icon>
										<div class="step-icon-wrapper complete-icon">
											<el-icon>
												<CircleCheckFilled />
											</el-icon>
										</div>
									</template>
									<template #title>
										<span class="step-title">已完成</span>
									</template>
									<template #description>
										<span class="step-time">{{ currentOrder.receipt_time || '--' }}</span>
									</template>
								</el-step>
							</el-steps>
								</div>
							</div>

							<!-- 物流信息 -->
							<div class="order-section">
								<div class="section-title">物流信息</div>
								<div class="logistics-timeline">
									<el-timeline>
										<!-- 物流动态 -->
										<el-timeline-item v-for="(item, index) in logisticsList" :key="index"
											:timestamp="item.time" placement="top"
											:type="index === 0 ? 'success' : 'primary'"
											:color="index === 0 ? '#67c23a' : '#ff8a5c'" size="large">
											<div>
												<div style="font-weight: 500; margin-bottom: 4px;">{{ item.context }}
												</div>
												<div v-if="item.areaName" style="color: #999; font-size: 12px;">{{
													item.areaName }}
												</div>
												<div v-if="item.status"
													style="color: #67c23a; font-size: 12px; margin-top: 4px;">{{
														item.status }}</div>
											</div>
										</el-timeline-item>

									</el-timeline>
									<div class="ship-info">

										<div class="ship-detail">
											<div class="detail-item">
												<span class="detail-label">快递公司：</span>
												<span class="detail-value">{{ currentOrder.expressCompany ||
													currentOrder.express_company || '-' }}</span>
											</div>
											<div class="detail-item">
												<span class="detail-label">快递单号：</span>
												<span class="detail-value">{{ currentOrder.expressCode ||
													currentOrder.express_code
													|| '-' }}</span>
											</div>
											<div class="detail-item">
												<span class="detail-label">收货人：</span>
												<span class="detail-value">{{ currentOrder.linkman ||
													(currentOrder.address &&
														currentOrder.address.name) || '-' }}</span>
											</div>
											<div class="detail-item">
												<span class="detail-label">收货电话：</span>
												<span class="detail-value">{{ currentOrder.phone ||
													(currentOrder.address &&
														currentOrder.address.phone) || '-' }}</span>
											</div>
											<div class="detail-item full-width">
												<span class="detail-label">收货地址：</span>
												<span class="detail-value">{{ 
													(currentOrder.province
														+ currentOrder.city + currentOrder.district +
													currentOrder.address)  }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- 订单信息 -->
							<div class="order-section">
								<div class="section-title">订单信息</div>
								<div class="order-info">
									<div class="info-item">
										<span class="info-label">订单号：</span>
										<span class="info-value">{{ currentOrder.pay_no }}</span>
									</div>
									<div class="info-item">
										<span class="info-label">订单状态：</span>
										<el-tag :type="getStatusType(currentOrder)" style="width: max-content;">{{
											getStatusText(currentOrder)
										}}</el-tag>
									</div>
									<div class="info-item">
										<span class="info-label">创建时间：</span>
										<span>{{ currentOrder.create_time }}</span>
									</div>
									<div class="info-item" v-if="currentOrder.pay_type">
								<span class="info-label">支付方式：</span>
								<span>{{ getPaymentMethodText(currentOrder.pay_type) }}</span>
							</div>
							<div class="info-item" v-if="currentOrder.freight_type">
								<span class="info-label">配送方式：</span>
								<span>{{ getFreightTypeText(currentOrder.freight_type) }}</span>
							</div>
								</div>
							</div>
							<!-- 对公账户信息 -->
							<div class="order-section" v-if="currentOrder.pay_type == 3">
								<div class="section-title">对公账户信息</div>
								<div class="order-info">
									<div class="info-item">
										<span class="info-label">开户银行：</span>
										<span class="info-value">{{ currentOrder.open_bank }}</span>
									</div>
									<div class="info-item">
										<span class="info-label">账户名称：</span>
										<span class="info-value">{{ currentOrder.bank_name }}</span>
									</div>
									<div class="info-item">
										<span class="info-label">银行账号：</span>
										<span class="info-value">{{ currentOrder.bank_no }}</span>
									</div>
								</div>
							</div>

							<!-- 收货地址 -->
							<!-- <div class="order-section" v-if="currentOrder.address">
								<div class="section-title">收货地址</div>
								<div class="address-section">
									<div class="address-item">
										<div class="address-info">
											<span class="address-name">{{ currentOrder.address.name }}</span>
											<span class="address-phone">{{ currentOrder.address.phone }}</span>
										</div>
										<div class="address-detail">{{ currentOrder.address.province }}{{
											currentOrder.address.city
										}}{{ currentOrder.address.district }}{{ currentOrder.address.detail }}</div>
									</div>
								</div>
							</div> -->

							<!-- 购买清单 -->
							<div class="order-section">
								<div class="section-title">购买清单</div>
								<div class="purchase-list">
									<div>
										<el-table :data="currentOrder.product"
											:header-cell-style="{ 'background-color': '#e5e5e5' }" size="small"
											style="width: 100%;">
											<el-table-column prop="img" label="实图" width="80" header-align="center"
												show-overflow-tooltip>
												<template #default="scope">
													<div v-if="!scope.row.img || scope.row.img.length <= 0">
														<div @click="preview(scope.row, scope.row.img)">
															<el-image :src="require('@/assets/img/error_img.png')"
																loading="lazy" />
														</div>
													</div>
													<div v-else>
														<div @click="preview(scope.row, scope.row.img)">
															<el-image :src="scope.row.img[0]" loading="lazy" />
														</div>
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="stock_type_txt" label="货物状态" header-align="center"
												width="170" show-overflow-tooltip>
												<template #default="scope">
													<div class="stock_type_txt_button">
														<span v-for="(item, idx) in scope.row.stock_type_txt_list"
															:key="idx">
															<el-button class="A" size="small" text bg
																v-if="item == '二手' || item == '过保' || item == '包附破损'"
																style="">{{ item }}</el-button>
															<el-button class="C" size="small" text bg v-else
																color="#ff8a5c">{{ item }}</el-button>
														</span>
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="brand_name" label="产品信息" show-overflow-tooltip>
												<template #default="scope">
													<div class="product-info">
														<div class="brand-name" v-if="scope.row.product_brand_name">
															{{ scope.row.product_brand_name }}
														</div>
														<div class="product-name" v-if="scope.row.product_name">
															{{ scope.row.product_name }}
														</div>
														<div class="product-details" v-if="scope.row.product_model">
															<span class="detail-label">型号</span><span
																class="label-colon">：</span>
															<span class="detail-value">{{ scope.row.product_model
															}}</span>
														</div>
														<div class="product-details" v-if="scope.row.product_order_no">
															<span class="detail-label">订货号</span><span
																class="label-colon">：</span>
															<span class="detail-value">{{ scope.row.product_order_no
															}}</span>
														</div>
														<div class="product-details">
															<span class="detail-label">单位</span><span
																class="label-colon">：</span>
															<span class="detail-value">{{ scope.row.product_unit
															}}</span>
														</div>

														<span
															v-if="!scope.row.product_brand_name && !scope.row.product_name && !scope.row.product_model && !scope.row.product_order_no">
															-
														</span>

													</div>
												</template>
											</el-table-column>
											<el-table-column prop="tsw_price" align="center" header-align="center"
												label="单价" width="120" show-overflow-tooltip>
												<template #default="scope">
													<span class="price-value">{{ scope.row.price }}</span>
												</template>
											</el-table-column>
											<el-table-column prop="num" label="数量" width="100" align="center"
												header-align="center">
												<template #default="scope">
													<span>{{ scope.row.num }}</span>
												</template>
											</el-table-column>
											<el-table-column prop="tsw_money" align="center" header-align="center"
												label="金额" width="120" show-overflow-tooltip>
												<template #default="scope">
													<span class="price-value">{{ scope.row.sum }}</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
							</div>

							<!-- 订单备注 -->
							<div class="order-section" v-if="currentOrder.remark">
								<div class="section-title">订单备注</div>
								<div class="remark-section">
									<div class="remark-content">{{ currentOrder.remark }}</div>
								</div>
							</div>

							<!-- 订单详情 -->
							<div class="order-section">
								<div class="section-title">订单详情</div>
								<div class="order-summary">
									<div class="summary-item">
										<span class="summary-label">商品数量：</span>
										<span class="summary-value">{{ currentOrder.total_num }} 件</span>
									</div>
									<div class="summary-item" v-if="currentOrder.freight_fee !== undefined">
										<span class="summary-label">快递费用：</span>
										<span class="summary-value">¥{{ currentOrder.freight_fee }}</span>
									</div>
									<div class="summary-item">
											<span class="summary-label">商品金额：</span>
											<span class="summary-value">¥{{ currentOrder.total_goods_money }}</span>
										</div>
										<div class="summary-item" v-if="Number(currentOrder.goods_discount) > 0">
											<span class="summary-label">优惠金额：</span>
											<span class="summary-value discount">
												<el-tag type="danger" size="small" effect="dark">省</el-tag>
												¥{{ currentOrder.goods_discount }}
											</span>
										</div>
										<div class="summary-divider"></div>
									<div class="summary-item total-item">
										<span class="summary-label">合计：</span>
										<span class="summary-value total-value">¥{{ currentOrder.total_order_money
										}}</span>
									</div>
								</div>
							</div>
							<!-- 底部固定栏 -->
							<div class="order-detail-footer">
								<div class="footer-left">
									<div class="total-info">
										<span class="total-label">商品数量：</span>
										<span class="total-value">{{ currentOrder.total_num || 0 }} 件</span>
									</div>
									<div class="total-info">
										<span class="total-label">订单金额：</span>
										<span class="total-amount">¥{{ currentOrder.total_order_money || '0.00'
										}}</span>
									</div>
								</div>
								<div class="footer-right">
									<el-button class="delete-btn" @click="handleDeleteOrder">删除订单</el-button>
								</div>
							</div>

						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
	<examineImg ref="examineImg"></examineImg>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import {
	ArrowLeft,
	DocumentAdd,
	Wallet,
	Box,
	Van,
	CircleCheckFilled,
	Clock,
	Checked
} from '@element-plus/icons-vue';
import '../../assets/user/index.css' //优化表格样式
import examineImg from '../public/img';
export default {
	components: {
		ArrowLeft,
		DocumentAdd,
		Wallet,
		Box,
		Van,
		CircleCheckFilled,
		Clock,
		Checked,
		examineImg
	},
	data() {
		return {
			tableData: [],
			form: {
				name: '',
				userinfo: '',
				type: '',
				status: '',
			},
			loading: false,
			total: 0,
			page: 1,
			tableHeight: 400,
			page_size: 120,
			user_id: '',
			// 订单状态标签页

			showDetail: false,
			currentOrder: {},
			logisticsList: [],
			srcList: [],
		}
	},
	props: {
		status: {
			type: String,
			default: ''
		}
	},
	mounted() {
		this.search();
		this.tableHeight_fun();
		this.user_id = localStorage.getItem('user_id');
		window.addEventListener('resize', this.tableHeight_fun);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.tableHeight_fun);
	},
	created() { },
	computed: {
		currentStepIndex() {
			const stateStepMap = {
				3: 1,
				0: 2,
				1: 3,
				2: 4,
				4: 5
			};
			return stateStepMap[this.currentOrder.state] || 0;
		}
	},
	watch: {
		status: {
			handler(newVal, oldVal) {
				if (newVal === oldVal) return;
				this.form.status = newVal;
				this.page = 1;
				this.showDetail = false;
				this.search();
			}
		}
	},
	methods: {
		preview(row, img) {
			this.srcList = [];
			var obj = this;
			if (img) {
				img.forEach(function (item) {
					obj.srcList.push(item)
				})
			}
			this.$refs['examineImg'].img_title = row;
			this.$refs['examineImg'].data = this.srcList;
			this.$refs['examineImg'].dialogTableVisible = true;
			this.$refs['examineImg'].imgBigUrl = this.srcList[0];
		},
		handleDeleteOrder() {
			ElMessageBox.confirm(
				'确定要删除该订单吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}
			).then(() => {
				ElMessage.success('订单已删除');
				this.backToList();
			}).catch(() => {
				ElMessage.info('已取消删除');
			});
		},
		async handleCancelOrder(order) {
			try {
				await ElMessageBox.confirm('确认取消订单吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})

				const res = await this.$axios.post('/api/yunsys.Order/cancelbills', {
					pay_no: order.pay_no
				})

				const data = res.data
				if (data.code === 0) {
				ElMessage.success('取消成功')
				this.search()
				this.$emit('refresh-order-nums')
			} else {
				ElMessage.error(data.msg || '取消失败')
			}
			} catch (err) {
				if (err !== 'cancel') {
					console.error('取消订单失败:', err)
					ElMessage.error('系统错误')
				}
			}
		},
		async handleConfirmReceipt(order) {
			try {
				await ElMessageBox.confirm('确认已收到商品吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})

				const res = await this.$axios.post('/api/yunsys.Order/confirmreceipt', {
					pay_no: order.pay_no
				})

				const data = res.data
				if (data.code === 0) {
				ElMessage.success('确认收货成功')
				this.search()
				this.$emit('refresh-order-nums')
			} else {
				ElMessage.error(data.msg || '确认收货失败')
			}
			} catch (err) {
				if (err !== 'cancel') {
					console.error('确认收货失败:', err)
					ElMessage.error('系统错误')
				}
			}
		},
		async handleReorder(order) {
			try {
				await ElMessageBox.confirm('确认购买相同商品？', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				});

				// 确认后打开购物车页面并带上订单号参数
				
				const { href } = this.$router.resolve({
					path: '/user',
					query: { pay_no: order.pay_no, type: 'shopping' }
				});
			window.open(href, '_blank');
			} catch (err) {
				if (err !== 'cancel') {
					console.error('再次下单失败:', err);
					ElMessage.error('系统错误');
				}
			}
		},
		header_table(event) {
			if (event.column.property == 'header') {
				return { 'background-color': '#fff' }
			} else {
				return { 'background-color': '#e5e5e5' }
			}
		},

		getStatusType(order) {
			const state = order.state;
			if (state === 0 && order.card_state === 1) {
				return 'warning';
			}
			const typeMap = {
				0: 'danger',
				1: 'warning',
				2: 'info',
				4: 'success',
				'-1': 'info',
			};
			return typeMap[state] || 'info';
		},
		getStatusText(order) {
			const state = order.state;
			if (state === 0 && order.card_state === 1) {
				return '待支付-等待审核';
			}
			const textMap = {
				0: '待支付',
				3: '等待商家确认',
				1: '待发货',
				2: '待收货',
				4: '已完成',
				'-1': '已取消',
			};
			return textMap[state] || state;
		},
		goToPay(order) {
			const { href } = this.$router.resolve({
				path: '/user',
				query: { pay_no: order.pay_no, type: 'order' }
			});
			window.open(href, '_blank');
		},
		async viewDetail(order) {
			this.loading = true;
			try {
				const res = await this.$axios.post('/api/yunsys.Order/getdetails', { pay_no: order.pay_no });
				const data = res.data;

				if (data.code !== 0) {
					ElMessage.error(data.msg || '获取订单详情失败');
					return;
				}

				this.currentOrder = data.data;
				if (this.currentOrder.product && this.currentOrder.product.forEach) {
					this.currentOrder.product.forEach(item => {
						item.stock_type_txt_list = item.stock_type_txt ? item.stock_type_txt.split("、") : [];
					});
				}

				// 获取物流详情
				if (this.currentOrder.express_code) {
					await this.fetchLogisticsDetail(order.pay_no);
				} else {
					this.logisticsList = [];
				}

				this.showDetail = true;
			} catch (err) {
				console.error('获取订单详情失败:', err);
				ElMessage.error('系统错误');
			} finally {
				this.loading = false;
			}
		},
		async fetchLogisticsDetail(pay_no) {
			try {
				const res = await this.$axios.post('/api/yunsys.Order/getstagelogict', { pay_no: pay_no });
				const data = res.data;
				console.log(data)
				if (data.code === 0 && data.data.data) {
					this.logisticsList = data.data.data;
				} else {
					this.logisticsList = [];
				}
			} catch (err) {
				console.error('获取物流详情失败:', err);
				this.logisticsList = [];
			}
		},
		backToList() {
			this.showDetail = false;
			this.currentOrder = {};
		},
		
		getPaymentMethodText(method) {
			const methodMap = {
				1: '微信支付',
				2: '支付宝',
				3: '对公转账',
				'wechat': '微信支付',
				'alipay': '支付宝',
				'cash': '现金',
				'bank': '银行转账'
			};
			return methodMap[method] || method;
		},
		getFreightTypeText(type) {
			const typeMap = {
				1: '快递运输',
				2: '到付'
			};
			return typeMap[type] || '-';
		},
		grabble() {
			if (this.showDetail && this.currentOrder.pay_no) {
				// 如果在详情页，刷新详情
				this.viewDetail(this.currentOrder);
			} else {
				// 如果在列表页，刷新列表
				this.page = 1;
				this.search();
				this.$emit('refresh-order-nums')
			}
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				if (this.$refs.height_top) {
					this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100;
				}
			})
		},
		getStateValue(status) {
			const stateMap = {
				'all': '',
				'pending_payment': 0,
				'pending_confirmation': 3,
				'pending_shipment': 1,
				'pending_receipt': 2,
				'completed': 4,
				'cancelled': -1
			};
			return stateMap[status] !== undefined ? stateMap[status] : '';
		},

		async search() {
			this.loading = true;
			try {
				const res = await this.$axios.post('/api/yunsys.Order/getbillslist', {
					state: this.getStateValue(this.status),
					page: this.page,
					ps: this.page_size
				});
				const data = res.data;
				this.loading = false;
				if (data.code !== 0) {
					return ElMessage({
						message: data.msg,
						type: 'error',
						grouping: true
					});
				}
				var obj = this;
				this.total = data.data.total || data.data.length || 0;
				var key = 0;
				const orderList = data.data.data || data.data || [];
				orderList.forEach(item => {
					key = key + 1;
					item.key = (obj.page - 1) * obj.page_size + key;
				});
				this.tableData = orderList;
			} catch (err) {
				this.loading = false;
				console.error('获取订单列表失败:', err);
				return ElMessage({
					message: '系统错误',
					type: 'error',
					grouping: true
				});
			}
		},
		
	}
}
</script>
<style lang="less" scoped>
.step-icon-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 26px;
	transition: all 0.3s ease;
}

.step-time {
	font-size: 12px;
	color: #999;
}

.order-progress-section {
	padding: 30px 20px;
}

.progress-steps {
	padding: 10px 0;
	width: 100%;
	overflow-x: auto;
}

.logistics-timeline {
	padding: 10px 20px;
}

.ship-info {
	background: linear-gradient(135deg, #fff5f0 0%, #ffe4d6 100%);
	border-radius: 12px;
	padding: 20px;
	border: 1px solid #ffd4c2;
}

.ship-title {
	font-size: 16px;
	font-weight: 600;
	color: #ff6b35;
	margin-bottom: 16px;
	display: flex;
	align-items: center;
	gap: 8px;
}

.ship-title::before {
	content: '';
	width: 4px;
	height: 16px;
	background: #ff8a5c;
	border-radius: 2px;
}

.ship-detail {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
}

.detail-item {
	flex: 1;
	min-width: 200px;
	display: flex;
	align-items: flex-start;
}

.detail-item.full-width {
	flex: 1 1 100%;
}

.detail-label {
	font-size: 14px;
	color: #666;
	white-space: nowrap;
	min-width: 80px;
}

.detail-value {
	font-size: 14px;
	color: #333;
	font-weight: 500;
	word-break: break-all;
}

// :deep(.el-step__title.is-process) {
// 	color: #ff8a5c !important;
// }

// :deep(.el-step__head.is-process) {
// 	color: #ff8a5c !important;
// }

:deep(.el-step__title.is-success) {
	color: #ff8a5c !important;
}

:deep(.el-step__head.is-success) {
	color: #ff8a5c !important;
}

:deep(.el-steps .el-step__line.is-wait) {
	background-color: #e5e5e5;
}

:deep(.el-steps .el-step__line.is-finish) {
	background-color: #ff8a5c;
}

:deep(.el-steps .el-step__icon.is-finish) {
	border-color: #ff8a5c;
	background-color: #ff8a5c;
	color: #fff;
}

:deep(.el-steps .el-step__icon.is-finish .step-icon-wrapper) {
	background-color: #ff8a5c;
	border-color: #ff8a5c;
	color: #fff;
}

:deep(.el-steps .el-step__icon.is-process) {
	border-color: #ff8a5c;
	background-color: #fff;
}

:deep(.el-steps .el-step__icon.is-process .step-icon-wrapper) {
	border-color: #ff8a5c;
	background: linear-gradient(135deg, #fff5f0 0%, #ffe4d6 100%);
	color: #ff8a5c;
}

:deep(.el-steps .el-step__title.is-finish) {
	color: #ff8a5c;
}

:deep(.el-timeline-item__timestamp.is-top) {
	font-size: 12px;
	color: #666;
}

/* 修改为固定在订单容器底部 */
.order-container {
	position: relative;
	// padding-bottom: 60px; /* 为底部栏预留空间 */
}

.order-detail-footer {
	position: sticky;
	bottom: 0;
	z-index: 100;
	background: #fff;
	border-top: 1px solid #e5e5e5;
	padding: 12px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
	z-index: 100;
}

.footer-left {
	display: flex;
	gap: 30px;
}

.total-info {
	display: flex;
	align-items: center;
}

.total-label {
	font-size: 14px;
	color: #666;
}

.total-value {
	font-size: 14px;
	color: #333;
}

.total-amount {
	font-size: 18px;
	font-weight: 600;
	color: #ff8a5c;
}

.footer-right {
	display: flex;
	gap: 10px;
}

.delete-btn {
	padding: 8px 24px;
	font-size: 14px;
	background: #fff;
	border: 1px solid #ff8a5c;
	color: #ff8a5c;
	border-radius: 4px;
	transition: all 0.3s ease;
}

.delete-btn:hover {
	background: #fff5f0;
}



/* 滚动条样式优化 */
/* Firefox 滚动条样式 */
:deep(.scroll-container) {
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;
	transition: scrollbar-color 0.2s ease;
}

:deep(.scroll-container:hover) {
	scrollbar-color: #c9cdd4 transparent;
}

/* Chrome/Safari 滚动条样式 */
:deep(.scroll-container::-webkit-scrollbar) {
	width: 6px;
	height: 6px;
}

:deep(.scroll-container::-webkit-scrollbar-thumb) {
	background-color: #e5e6eb;
	border-radius: 6px;
	opacity: 0;
	transition: all 0.2s ease;
}

:deep(.scroll-container:hover::-webkit-scrollbar-thumb) {
	opacity: 1;
	background-color: #c9cdd4;
}

:deep(.scroll-container::-webkit-scrollbar-track) {
	background: transparent;
}

/* 详情页样式 */
.detail-header {
	padding-bottom: 10px;
	padding-top: 10px;
}

.price-value {
	color: #ff8a5c;
	font-weight: 600;
}

/* 以下是从订单详情页复制的样式 */
.order-detail-page {
	background: #f5f7fa;
	padding: 10px 5px 0px 4px;
}



.order-section {
	background: #fff;
	border-radius: 12px;
	padding: 24px;
	margin-bottom: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #333;
	margin-bottom: 16px;
	padding-bottom: 12px;
	display: flex;
	align-items: center;

	&::before {
		content: '';
		display: inline-block;
		width: 4px;
		height: 16px;
		background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
		border-radius: 2px;
		margin-right: 10px;
	}
}

.order-info {
	background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
	padding: 16px;
	border-radius: 8px;
	border: 1px solid #ffe4d6;
}

.info-item {
	font-size: 14px;
	margin-bottom: 8px;
	line-height: 27px;

	&:last-child {
		margin-bottom: 0;
	}
}

.info-label {
	color: #666;
	margin-right: 8px;
}

.info-value {
	color: #ff8a5c;
	font-weight: 600;
	font-family: 'Courier New', monospace;
}

.address-section {
	.address-item {
		padding: 16px;
		border: 2px solid #e8e8e8;
		border-radius: 8px;
		background: #fafafa;
	}

	.address-info {
		margin-bottom: 8px;
	}

	.address-name {
		font-weight: 600;
		color: #333;
		margin-right: 12px;
	}

	.address-phone {
		color: #666;
	}

	.address-detail {
		color: #666;
		font-size: 14px;
	}
}

.remark-section {
	.remark-content {
		padding: 12px;
		background: #fafafa;
		border-radius: 8px;
		border: 1px solid #e5e5e5;
		color: #333;
		font-size: 14px;
	}
}

.order-summary {
	.summary-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 0;
		font-size: 14px;
	}

	.summary-label {
		color: #666;
	}

	.summary-value {
		color: #333;
	}

	.summary-divider {
		height: 1px;
		background: #e8e8e8;
		margin: 8px 0;
	}

	.total-item {
		padding-top: 12px;
		font-size: 16px;
	}

	.total-value {
		color: #ff8a5c;
		font-weight: 700;
		font-size: 20px;
	}

	.discount {
		color: #ff4d4f;
		font-weight: 700;
		font-size: 16px;
		display: flex;
		align-items: center;
		gap: 4px;
		.el-tag {
			font-size: 11px;
			padding: 0 6px;
			height: 20px;
			line-height: 20px;
			border-radius: 3px;
		}
	}
}

.product-info {
	padding: 8px 0;
}

.brand-name {
	font-weight: 600;
	color: #333;
	margin-bottom: 4px;
}

.product-name {
	color: #333;
	margin-bottom: 4px;
}

.product-details {
	color: #666;
	font-size: 13px;
}

.detail-label {
	color: #999;
}

.label-colon {
	margin: 0 4px;
}

.detail-value {
	color: #333;
}

.stock_type_txt_button .el-button {
	margin-right: 5px;
	font-size: 0.70rem !important;
	padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
	color: #ff8a5c;
	background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205);
	background-color: rgb(223, 255, 251) !important;
}

:deep(.el-image) {
	border-radius: 3px;
	height: 60px;
	width: 60px;
	display: inline-block;
	display: flex;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
	background-color: #ff8a5c;
}

/* 订单卡片列表样式 */
.order-card-container {
	background: #f5f7fa;
	padding: 6px 6px 5px 16px;
}

.order-card-list {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.order-card {
	background: #fff;
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
	transition: all 0.3s ease;
}

.order-card:hover {
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
	transform: translateY(-2px);
}

.card-header {
	display: flex;
	gap: 40px;
	padding-bottom: 16px;
	border-bottom: 1px solid #f0f0f0;
	margin-bottom: 16px;
	align-items: center;
}



.confirm-tip {
	margin-left: auto;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 16px;
	background: linear-gradient(135deg, #fff7e6 0%, #fff 100%);
	border: 1px solid #ffd591;
	border-radius: 6px;
	color: #fa8c16;
	font-size: 13px;
	font-weight: 500;
	animation: pulse 2s infinite;
}

@keyframes pulse {
	0%, 100% {
		opacity: 1;
	}
	50% {
		opacity: 0.8;
	}
}

.confirm-tip {
	display: flex;
	align-items: center;
	gap: 4px;
	margin-left: auto;
	flex-shrink: 0;
	font-size: 14px;
	color: #ff8a5c;
	background: #fff5f0;
	padding: 4px 12px;
	border-radius: 4px;
}

.header-item {
	display: flex;
	flex-direction: column;
	gap: 4px;
	line-height: 27px;
}

.item-label {
	font-size: 12px;
	color: #999;
}

.item-value {
	font-size: 14px;
	color: #333;
}

.order-no {
	font-family: 'Courier New', monospace;
	font-weight: 600;
}

.card-body {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.body-left {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.info-row {
	display: flex;
	gap: 40px;
}

.info-item {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.info-label {
	font-size: 12px;
	color: #999;
}

.info-value {
	font-size: 16px;
	color: #333;
}

.price {
	color: #ff8a5c;
	font-weight: 700;
}

.discount {
	color: #ff4d4f;
	font-weight: 700;
	font-size: 16px;
	display: flex;
	align-items: center;
	gap: 4px;
}

.discount .el-tag {
	font-size: 11px;
	padding: 0 6px;
	height: 20px;
	line-height: 20px;
	border-radius: 3px;
}

.status-row {
	display: flex;
	align-items: center;
}

.body-right {
	display: flex;
	gap: 8px;
}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
	.search_remark {
		width: 120px;
	}
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
	.search_remark {
		width: 170px;
	}
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}

/* 滚动条样式优化 */
/* Firefox 滚动条样式 */
:deep(.order-card-container) {
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;
	transition: scrollbar-color 0.2s ease;
}

:deep(.order-card-container:hover) {
	scrollbar-color: #c9cdd4 transparent;
}

/* Chrome/Safari 滚动条样式 */
:deep(.order-card-container::-webkit-scrollbar) {
	width: 6px;
	height: 6px;
}

:deep(.order-card-container::-webkit-scrollbar-thumb) {
	background-color: #e5e6eb;
	border-radius: 6px;
	opacity: 0;
	transition: all 0.2s ease;
}

:deep(.order-card-container:hover::-webkit-scrollbar-thumb) {
	opacity: 1;
	background-color: #c9cdd4;
}

:deep(.order-card-container::-webkit-scrollbar-track) {
	background: transparent;
}
</style>